import React from "react";
import Accordion from "react-bootstrap/Accordion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";

import greenCheck from "../../../assets/green-check.png";
import viewIcon from "../../../assets/view-icon.png";
import deleteIcon from "../../../assets/delete-icon.png";
import { handleEyeClick } from "../../../shared/utils/fileDownload";
import { toast } from "react-toastify";

const Details = ({
  formData,
  setFormData,
  handleChange,
  handleAddressChange,
  errors,
  setErrors,
  handleAddressProofUpload,
  handleProfileDocumentUpload,
  handleDeleteProfileDocument,
  states,
  districts,
  cities,
}) => {
  const hasPanDocument = !!formData.panFileUrl;
  const hasPanNumber = !!formData.panNo;
  // console.log("hasPan======", hasPan);
  const hasPassport = !!formData.passportFileUrl;
  const hasDrivingLicence = !!formData.drivingLicenceFileUrl;
  const hasVoterId = !!formData.voterIdFileUrl;
  const getDistrictsByState = (stateId) => {
    return districts?.filter((district) => district.stateId === stateId) || [];
  };

  const getCitiesByDistrict = (districtId) => {
    return cities?.filter((city) => city.districtId === districtId) || [];
  };

  return (
    <>
      {/* Personal Details */}
      <div className="px-4 pb-4 rounded row g-4 formfields bg-white border shadow-sm mb-5">
        {/* <p
                    className="tab_headers"
                    style={{ marginBottom: "0px", marginTop: "1rem" }}
                >
                    Personal Details
                </p> */}
        <div className="section-header">
          <span className="section-header-title">Personal Details</span>
        </div>
        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            Name <span className="text-danger">*</span>
          </label>

          <input
            type="text"
            className={`form-control onboarding-input ${
              errors?.fullNameSSC ? "is-invalid" : ""
            }`}
            name="fullNameSSC"
            value={formData.fullNameSSC || ""}
            onChange={handleChange}
            disabled
          />

          {errors?.fullNameSSC && (
            <div className="invalid-feedback">{errors.fullNameSSC}</div>
          )}
        </div>

        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            Gender <span className="text-danger">*</span>
          </label>
          <select
            className={`form-select onboarding-input ${errors?.gender ? "is-invalid" : ""}`}
            name="gender"
            value={formData.gender}
            onChange={handleChange}
            disabled
          >
            <option value="">Select Gender</option>
            <option>Male</option>
            <option>Female</option>
            <option>Other</option>
          </select>
          {errors.gender && (
            <small className="text-danger">{errors.gender}</small>
          )}
        </div>

        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            Date Of Birth <span className="text-danger">*</span>
          </label>
          <input
            type="date"
            className={`form-control onboarding-input ${errors?.dob ? "is-invalid" : ""}`}
            name="dob"
            value={formData.dob}
            onChange={handleChange}
            disabled
          />
          {errors?.dob && <small className="text-danger">{errors.dob}</small>}
        </div>
        <div className="col-lg-3 col-md-4">
          <label className="form-label">
            Mobile No<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            placeholder="Enter Mobile No"
            disabled
            className={`form-control ${errors?.mobile ? "is-invalid" : ""}`}
            name="mobile"
            value={formData.mobile || ""}
            onChange={handleChange}
          />
          {errors?.mobile && (
            <div className="invalid-feedback">{errors.mobile}</div>
          )}
        </div>
        <div className="col-lg-3 col-md-4">
          <label className="form-label">
            Email Address<span className="text-danger">*</span>
          </label>
          <input
            type="email"
            placeholder="Enter Email Address"
            disabled
            className={`form-control ${errors?.email ? "is-invalid" : ""}`}
            name="email"
            value={formData.email || ""}
            onChange={handleChange}
          />

          {errors?.email && (
            <div className="invalid-feedback">{errors.email}</div>
          )}
        </div>
        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            Marital Status <span className="text-danger">*</span>
          </label>
          <select
            className={`form-select onboarding-input ${
              errors?.maritalStatus ? "is-invalid" : ""
            }`}
            name="maritalStatus"
            value={formData.maritalStatus}
            onChange={handleChange}
            disabled
          >
            <option value="">Select</option>
            <option>Unmarried</option>
            <option>Married</option>
            <option>Widow</option>
            <option>Divorced</option>
            <option>Judicially Separated</option>
          </select>
          {errors?.maritalStatus && (
            <small className="text-danger">{errors.maritalStatus}</small>
          )}
        </div>

        {/* <div className="col-lg-3 col-md-6">
          <label className="form-label">CIBIL Score</label>

          <input
            type="text"
            maxLength={3}
            placeholder="Enter CIBIL Score"
            className={`form-control onboarding-input ${
              errors?.cibilScore ? "is-invalid" : ""
            }`}
            name="cibilScore"
            value={formData.cibilScore}
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9]/g, "");

              handleChange({
                target: {
                  name: "cibilScore",
                  value,
                  type: "text",
                },
              });
            }}
          />

          {errors?.cibilScore && (
            <small className="text-danger">{errors.cibilScore}</small>
          )}
        </div> */}

        {/* <div className="col-lg-3 col-md-6">
          <label className="form-label">CIBIL Score As On Date</label>
          <input
            type="date"
            className={`form-control onboarding-input ${
              errors?.cibilScoreDate ? "is-invalid" : ""
            }`}
            name="cibilScoreDate"
            value={formData.cibilScoreDate}
            onChange={handleChange}
            max={new Date().toISOString().split("T")[0]}
          />
          {errors?.cibilScoreDate && (
                        <small className="text-danger">
                            {errors.cibilScoreDate}
                        </small>
                    )}
        </div> */}

        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            Person With Disability<span className="text-danger">*</span>
          </label>
          <select
            className={`form-select onboarding-input ${errors?.personWithDisability ? "is-invalid" : ""}`}
            name="personWithDisability"
            disabled
            value={formData.personWithDisability}
            onChange={handleChange}
          >
            <option value="">Select</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
          {errors?.personWithDisability && (
            <small className="text-danger">{errors.personWithDisability}</small>
          )}
        </div>

        {formData.personWithDisability === "Yes" && (
          <>
            <div className="col-lg-3 col-md-6">
              <label className="form-label">
                Name of Board Issued the Disability Certificate
                <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className={`form-control onboarding-input ${errors?.disabilityBoardName ? "is-invalid" : ""}`}
                name="disabilityBoardName"
                placeholder="Enter board name"
                value={formData.disabilityBoardName}
                onChange={(e) => {
                  const value = e.target.value;

                  if (/^[A-Za-z\s.,&()-]*$/.test(value)) {
                    handleChange({
                      target: {
                        name: "disabilityBoardName",
                        value,
                      },
                    });
                  }
                }}
              />
              {errors?.disabilityBoardName && (
                <small className="text-danger">
                  {errors.disabilityBoardName}
                </small>
              )}
            </div>

            <div className="col-lg-3 col-md-6">
              <label className="form-label">
                Reference Number of Disability Certificate
                <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className={`form-control onboarding-input ${
                  errors?.disabilityReferenceNumber ? "is-invalid" : ""
                }`}
                name="disabilityReferenceNumber"
                placeholder="Enter reference number"
                value={formData.disabilityReferenceNumber}
                onChange={(e) => {
                  const value = e.target.value;

                  if (/^[A-Za-z0-9/-]*$/.test(value)) {
                    handleChange({
                      target: {
                        name: "disabilityReferenceNumber",
                        value,
                      },
                    });
                  }
                }}
              />
              {errors?.disabilityReferenceNumber && (
                <small className="text-danger">
                  {errors.disabilityReferenceNumber}
                </small>
              )}
            </div>

            <div className="col-lg-3 col-md-6">
              <label className="form-label">
                Certificate Of Disability Issued On
                <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className={`form-control onboarding-input ${
                  errors?.disabilityCertificateDate ? "is-invalid" : ""
                }`}
                name="disabilityCertificateDate"
                value={formData.disabilityCertificateDate}
                onChange={handleChange}
                max={new Date().toISOString().split("T")[0]}
              />
              {errors?.disabilityCertificateDate && (
                <small className="text-danger">
                  {errors.disabilityCertificateDate}
                </small>
              )}
            </div>

            <div className="col-lg-3 col-md-6">
              <label className="form-label">
                Upload Disability Certificate
              </label>

              {!formData.disabilityFile ? (
                <div
                  className="border rounded d-flex flex-column align-items-center justify-content-center upload-box"
                  style={{
                    minHeight: "100px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    document.getElementById("disabilityFileInput").click()
                  }
                >
                  <FontAwesomeIcon icon={faUpload} className="text-secondary" />

                  <div
                    className="mt-2"
                    style={{
                      color: "#7b7b7b",
                      fontWeight: "500",
                    }}
                  >
                    Click to upload
                  </div>

                  <div className="text-muted" style={{ fontSize: "12px" }}>
                    PDF, JPG or PNG (Max 2MB)
                  </div>

                  <input
                    id="disabilityFileInput"
                    type="file"
                    disabled
                    accept=".jpg,.jpeg,.png,.pdf"
                    style={{ display: "none" }}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        disabilityFile: e.target.files[0],
                      })
                    }
                  />
                </div>
              ) : (
                <div
                  className="uploaded-file-box p-3 d-flex justify-content-between align-items-center"
                  style={{
                    border: "2px solid #bfc8e2",
                    borderRadius: "8px",
                    background: "#f7f9fc",
                  }}
                >
                  <div className="d-flex align-items-center">
                    <img
                      src={greenCheck}
                      alt="check"
                      style={{
                        width: "22px",
                        height: "22px",
                        marginRight: "10px",
                      }}
                    />

                    <div>
                      <div
                        style={{
                          fontWeight: 600,
                          color: "#42579f",
                        }}
                      >
                        {formData.disabilityName}
                      </div>
                    </div>
                  </div>

                  <div className="d-flex gap-2">
                    <img
                      src={viewIcon}
                      alt="View"
                      style={{
                        width: "25px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleEyeClick(formData.disabilityFile)}
                    />
                  </div>
                </div>
              )}
              {errors?.disabilityFile && (
                <small className="text-danger d-block mt-1">
                  {errors.disabilityFile}
                </small>
              )}
            </div>
            <div className="row mb-4 mt-4">
              {formData.disabilities?.map((dis, index) => (
                <div key={index} className="col-12 mb-3">
                  <div
                    className="card h-100 border-0 shadow-sm"
                    style={{
                      borderRadius: "12px",
                      background: "#f8fafc",
                      paddingRight: "0px",
                    }}
                  >
                    <div
                      className="card-header d-flex justify-content-between align-items-center"
                      style={{
                        background: "#42579f",
                        color: "#fff",
                      }}
                    >
                      <span>Disability {index + 1}</span>

                      {/* <span className="badge bg-light text-dark">
                                                {dis.disabilityPercentage}%
                                            </span> */}
                    </div>

                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-6">
                          <label className="form-label">
                            Nature Of Disability
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={dis.natureOfDisability || ""}
                            disabled
                          />
                        </div>

                        <div className="col-md-6">
                          <label className="form-label">
                            Disability Percentage
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={`${dis.disabilityPercentage || 0}%`}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            Religion<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            placeholder="Enter religion"
            className={`form-control ${errors?.religion ? "is-invalid" : ""}`}
            name="religion"
            disabled
            value={formData.religion || ""}
            onChange={handleChange}
          />
          {errors?.religion && (
            <div className="invalid-feedback">{errors.religion}</div>
          )}
        </div>

        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            Minority<span className="text-danger">*</span>
          </label>
          <select
            className={`form-select ${errors?.minority ? "is-invalid" : ""}`}
            name="minority"
            disabled
            value={formData.minority || ""}
            onChange={handleChange}
          >
            <option value="">Select</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
          {errors?.minority && (
            <div className="invalid-feedback">{errors.minority}</div>
          )}
        </div>

        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            Caste Category<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            placeholder="Enter caste category"
            disabled
            className={`form-control ${errors?.casteCategory ? "is-invalid" : ""}`}
            name="casteCategory"
            value={formData.casteCategory || ""}
            onChange={handleChange}
          />
          {errors?.casteCategory && (
            <div className="invalid-feedback">{errors.casteCategory}</div>
          )}
        </div>

        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            Caste Community<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            placeholder="Enter caste community"
            disabled
            className={`form-control ${errors?.casteCommunity ? "is-invalid" : ""}`}
            name="casteCommunity"
            value={formData.casteCommunity || ""}
            onChange={handleChange}
          />
          {errors?.casteCommunity && (
            <div className="invalid-feedback">{errors.casteCommunity}</div>
          )}
        </div>

        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            Nationality<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            placeholder="Enter nationality"
            disabled
            className={`form-control ${errors?.nationality ? "is-invalid" : ""}`}
            name="nationality"
            value={formData.nationality || ""}
            onChange={handleChange}
          />
          {errors?.nationality && (
            <div className="invalid-feedback">{errors.nationality}</div>
          )}
        </div>
        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            State<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            placeholder="Enter state of domicile"
            disabled
            className={`form-control ${errors?.stateOfDomicile ? "is-invalid" : ""}`}
            name="stateOfDomicile"
            value={formData.stateOfDomicile || ""}
            onChange={handleChange}
          />
          {errors?.stateOfDomicile && (
            <div className="invalid-feedback">{errors.stateOfDomicile}</div>
          )}
        </div>

        {/* <div className="col-lg-3 col-md-6">
          <label className="form-label">
            State Of Origin<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            disabled
            placeholder="Enter state of origin"
            className={`form-control ${errors?.stateOfOrigin ? "is-invalid" : ""}`}
            name="stateOfOrigin"
            value={formData.stateOfOrigin || ""}
            onChange={handleChange}
          />
          {errors?.stateOfOrigin && (
            <div className="invalid-feedback">{errors.stateOfOrigin}</div>
          )}
        </div> */}

        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            District<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            placeholder="Enter domicile district"
            disabled
            className={`form-control ${errors?.domicileDistrict ? "is-invalid" : ""}`}
            name="domicileDistrict"
            value={formData.domicileDistrict || ""}
            onChange={handleChange}
          />
          {errors?.domicileDistrict && (
            <div className="invalid-feedback">{errors.domicileDistrict}</div>
          )}
        </div>

        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            City/Town <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            placeholder="Enter city/town of domicile"
            disabled
            className={`form-control ${errors?.domicileCity ? "is-invalid" : ""}`}
            name="domicileCity"
            value={formData.domicileCity || ""}
            onChange={handleChange}
          />
          {errors?.domicileCity && (
            <div className="invalid-feedback">{errors.domicileCity}</div>
          )}
        </div>

        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            Blood Group <span className="text-danger">*</span>
          </label>

          <select
            className={`form-select ${errors?.bloodGroup ? "is-invalid" : ""}`}
            name="bloodGroup"
            value={formData.bloodGroup || ""}
            onChange={handleChange}
          >
            <option value="">Select Blood Group</option>
            <option value="A+">A+</option>
            <option value="A-">A-</option>
            <option value="B+">B+</option>
            <option value="B-">B-</option>
            <option value="AB+">AB+</option>
            <option value="AB-">AB-</option>
            <option value="O+">O+</option>
            <option value="O-">O-</option>
          </select>

          {errors?.bloodGroup && (
            <div className="invalid-feedback">{errors.bloodGroup}</div>
          )}
        </div>
        {/* PAN */}
        {hasPanDocument ? (
          <>
            {/* PAN Number */}
            <div className="col-lg-3 col-md-4">
              <label className="form-label">PAN No.</label>

              <input
                type="text"
                className="form-control"
                value={formData.panNo || ""}
                 disabled={formData.panFromApi === true}
              />
            </div>

            {/* Uploaded PAN */}
            <div className="col-lg-3 col-md-4">
              <label className="form-label">PAN Card Document</label>

              <div
                className="uploaded-file-box p-3 d-flex justify-content-between align-items-center"
                style={{
                  border: "2px solid #bfc8e2",
                  borderRadius: "8px",
                  background: "#f7f9fc",
                }}
              >
                <div className="d-flex align-items-center">
                  <img
                    src={greenCheck}
                    alt="check"
                    style={{
                      width: "22px",
                      height: "22px",
                      marginRight: "10px",
                    }}
                  />

                  <div>
                    <div
                      style={{
                        fontWeight: 600,
                        color: "#42579f",
                      }}
                    >
                      {formData.panFileName || "PAN Card"}
                    </div>

                    <div className="text-muted" style={{ fontSize: "12px" }}>
                      Uploaded Document
                    </div>
                  </div>
                </div>

                <div className="d-flex gap-2">
                  <img
                    src={viewIcon}
                    alt="View"
                    style={{
                      width: "25px",
                      cursor: "pointer",
                    }}
                    onClick={() => handleEyeClick(formData.panFileUrl)}
                  />

                  {formData.panCanDelete && (
                    <img
                      src={deleteIcon}
                      alt="Delete"
                      style={{
                        width: "25px",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        handleDeleteProfileDocument(
                          formData.panDocumentId,
                          "panFile",
                          "panFileUrl",
                          "panFileName",
                          "panDocumentId",
                        )
                      }
                    />
                  )}
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            {/* PAN Number */}
            <div className="col-lg-3 col-md-4">
              <label className="form-label">PAN No.</label>

              <input
                type="text"
                placeholder="Enter PAN No"
                className={`form-control ${errors?.panNo ? "is-invalid" : ""}`}
                 //disabled={formData.panFromApi === true}
                name="panNo"
                value={formData.panNo || ""}
                onChange={handleChange}
              />

              {errors?.panNo && (
                <div className="invalid-feedback">{errors.panNo}</div>
              )}
            </div>

            {!hasPanNumber ? (
              <div className="col-lg-3 col-md-4">
                <label className="form-label">
                  If PAN Applied, Reference No.
                </label>

                <input
                  type="text"
                  placeholder="Enter Reference No."
                  className={`form-control ${
                    errors?.panReferenceNo ? "is-invalid" : ""
                  }`}
                  name="panReferenceNo"
                  value={formData.panReferenceNo || ""}
                  onChange={handleChange}
                />

                {errors?.panReferenceNo && (
                  <div className="invalid-feedback">
                    {errors.panReferenceNo}
                  </div>
                )}
              </div>
            ) : (
              <div className="col-lg-3 col-md-4">
                <label className="form-label">PAN Card Document</label>

                <div
                  className="border rounded d-flex flex-column align-items-center justify-content-center upload-box"
                  style={{
                    minHeight: "100px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    document.getElementById("panFileInput").click()
                  }
                >
                  <FontAwesomeIcon icon={faUpload} className="text-secondary" />

                  <div
                    className="mt-2"
                    style={{
                      color: "#7b7b7b",
                      fontWeight: "500",
                    }}
                  >
                    Click to upload
                  </div>

                  <div className="text-muted" style={{ fontSize: "12px" }}>
                    PDF, JPG or PNG (Max 2MB)
                  </div>

                  <input
                    id="panFileInput"
                    type="file"
                    accept=".jpg,.jpeg,.png,.pdf"
                    style={{ display: "none" }}
                    onChange={(e) => {
                      const file = e.target.files[0];

                      if (!file) return;

                      const allowedTypes = [
                        "image/jpeg",
                        "image/jpg",
                        "image/png",
                        "application/pdf",
                      ];

                      if (!allowedTypes.includes(file.type)) {
                        toast.error(
                          "Only JPG, JPEG, PNG and PDF files are allowed",
                        );
                        e.target.value = "";
                        return;
                      }

                      if (file.size > 2 * 1024 * 1024) {
                        toast.error("File size should not exceed 2 MB");
                        e.target.value = "";
                        return;
                      }

                      handleProfileDocumentUpload(
                        file,
                        "PAN_CARD",
                        "panFile",
                        "panFileUrl",
                        "panFileName",
                        "panDocumentId",
                      );
                    }}
                  />
                </div>

                {errors?.panFile && (
                  <small className="text-danger">{errors.panFile}</small>
                )}
              </div>
            )}
          </>
        )}
        {/* Show Reference No only when PAN number is not available */}
        {/* {!formData.panNo && (
          <div className="col-lg-3 col-md-4">
            <label className="form-label">If PAN Applied, Reference No.</label>

            <input
              type="text"
              placeholder="EnterReference No"
              className={`form-control ${
                errors?.panReferenceNo ? "is-invalid" : ""
              }`}
              name="panReferenceNo"
              value={formData.panReferenceNo || ""}
              onChange={handleChange}
            />
          </div>
        )} */}

        <div className="col-lg-3 col-md-4">
          <label className="form-label">Voter ID Card Number</label>
          <input
            type="text"
            maxLength={10}
            placeholder="Enter Voter ID Card Number"
            className={`form-control ${errors?.voterId ? "is-invalid" : ""}`}
            name="voterId"
            value={formData.voterId || ""}
            onChange={(e) => {
              const value = e.target.value
                .toUpperCase()
                .replace(/[^A-Z0-9]/g, "");

              handleChange({
                target: {
                  name: "voterId",
                  value,
                },
              });
            }}
          />
          {errors?.voterId && (
            <div className="invalid-feedback">{errors.voterId}</div>
          )}
        </div>
        <div className="col-lg-3 col-md-4">
          <label className="form-label">Voter ID Document</label>

          {!hasVoterId ? (
            <div
              className="border rounded d-flex flex-column align-items-center justify-content-center upload-box"
              style={{
                minHeight: "100px",
                cursor: "pointer",
              }}
              onClick={() =>
                document.getElementById("voterIdFileInput").click()
              }
            >
              <FontAwesomeIcon icon={faUpload} className="text-secondary" />

              <div
                className="mt-2"
                style={{
                  color: "#7b7b7b",
                  fontWeight: "500",
                }}
              >
                Click to upload
              </div>

              <div className="text-muted" style={{ fontSize: "12px" }}>
                PDF, JPG or PNG (Max 2MB)
              </div>

              <input
                id="voterIdFileInput"
                type="file"
                accept=".jpg,.jpeg,.png,.pdf"
                style={{ display: "none" }}
                onChange={(e) => {
                  const file = e.target.files[0];

                  if (!file) return;

                  const allowedTypes = [
                    "image/jpeg",
                    "image/jpg",
                    "image/png",
                    "application/pdf",
                  ];

                  if (!allowedTypes.includes(file.type)) {
                    toast.error(
                      "Only JPG, JPEG, PNG and PDF files are allowed",
                    );
                    e.target.value = "";
                    return;
                  }

                  if (file.size > 2 * 1024 * 1024) {
                    toast.error("File size should not exceed 2 MB");
                    e.target.value = "";
                    return;
                  }

                  handleProfileDocumentUpload(
                    e.target.files[0],
                    "VOTER_ID",
                    "voterIdFile",
                    "voterIdFileUrl",
                    "voterIdFileName",
                    "voterIdDocumentId",
                  );
                }}
              />
            </div>
          ) : (
            <div
              className="uploaded-file-box p-3 d-flex justify-content-between align-items-center"
              style={{
                border: "2px solid #bfc8e2",
                borderRadius: "8px",
                background: "#f7f9fc",
              }}
            >
              <div className="d-flex align-items-center">
                <img
                  src={greenCheck}
                  alt="check"
                  style={{
                    width: "22px",
                    height: "22px",
                    marginRight: "10px",
                  }}
                />

                <div>
                  <div
                    style={{
                      fontWeight: 600,
                      color: "#42579f",
                    }}
                  >
                    {formData.voterIdFileName || "Voter ID"}
                  </div>

                  <div className="text-muted" style={{ fontSize: "12px" }}>
                    Uploaded Document
                  </div>
                </div>
              </div>

              <img
                src={viewIcon}
                alt="View"
                style={{
                  width: "25px",

                  cursor: "pointer",
                }}
                onClick={() => handleEyeClick(formData.voterIdFileUrl)}
              />

              <img
                src={deleteIcon}
                alt="Delete"
                style={{
                  width: "25px",
                  cursor: "pointer",
                  marginLeft: "10px",
                }}
                onClick={() =>
                  handleDeleteProfileDocument(
                    formData.voterIdDocumentId,
                    "voterIdFile",
                    "voterIdFileUrl",
                    "voterIdFileName",
                    "voterIdDocumentId",
                  )
                }
              />
            </div>
          )}

          {errors?.voterIdFile && (
            <small className="text-danger d-block mt-1">
              {errors.voterIdFile}
            </small>
          )}
        </div>

        {/* DRIVING LICENCE */}

        <>
          <div className="col-lg-3 col-md-4">
            <label className="form-label">Driving License No</label>

            <input
              type="text"
              maxLength={15}
              placeholder="Enter Driving License No"
              className={`form-control ${
                errors?.drivingLicenseNo ? "is-invalid" : ""
              }`}
              name="drivingLicenseNo"
              value={formData.drivingLicenseNo || ""}
              onChange={(e) => {
                const value = e.target.value
                  .toUpperCase()
                  .replace(/[^A-Z0-9]/g, "");

                handleChange({
                  target: {
                    name: "drivingLicenseNo",
                    value,
                  },
                });
                
              }}
               disabled={formData.drivingLicenceFromApi === true}
            />

            {errors?.drivingLicenseNo && (
              <div className="invalid-feedback">{errors.drivingLicenseNo}</div>
            )}
          </div>

          <div className="col-lg-3 col-md-4">
            <label className="form-label">Driving Licence Document</label>

            {!hasDrivingLicence ? (
              /* SAME upload box as Voter ID */

              <div
                className="border rounded d-flex flex-column align-items-center justify-content-center upload-box"
                style={{ minHeight: "100px", cursor: "pointer" }}
                onClick={() =>
                  document.getElementById("drivingLicenceFileInput").click()
                }
              >
                <FontAwesomeIcon icon={faUpload} className="text-secondary" />

                <div
                  className="mt-2"
                  style={{ color: "#7b7b7b", fontWeight: 500 }}
                >
                  Click to upload
                </div>

                <div className="text-muted" style={{ fontSize: "12px" }}>
                  PDF, JPG or PNG (Max 2MB)
                </div>

                <input
                  id="drivingLicenceFileInput"
                  type="file"
                  hidden
                  accept=".jpg,.jpeg,.png,.pdf"
                  onChange={(e) => {
                    const file = e.target.files[0];

                    if (!file) return;

                    const allowedTypes = [
                      "image/jpeg",
                      "image/jpg",
                      "image/png",
                      "application/pdf",
                    ];

                    if (!allowedTypes.includes(file.type)) {
                      toast.error(
                        "Only JPG, JPEG, PNG and PDF files are allowed",
                      );
                      e.target.value = "";
                      return;
                    }

                    if (file.size > 2 * 1024 * 1024) {
                      toast.error("File size should not exceed 2 MB");
                      e.target.value = "";
                      return;
                    }

                    handleProfileDocumentUpload(
                      e.target.files[0],
                      "DRIVING_LICENSE",
                      "drivingLicenceFile",
                      "drivingLicenceFileUrl",
                      "drivingLicenceFileName",
                      "drivingLicenceDocumentId",
                    );
                  }}
                />
              </div>
            ) : (
              /* SAME uploaded card as Voter ID */

              <div
                className="uploaded-file-box p-3 d-flex justify-content-between align-items-center"
                style={{
                  border: "2px solid #bfc8e2",
                  borderRadius: "8px",
                  background: "#f7f9fc",
                }}
              >
                <div className="d-flex align-items-center">
                  <img src={greenCheck} alt="" width={22} />

                  <div className="ms-2">
                    <div style={{ fontWeight: 600, color: "#42579f" }}>
                      {formData.drivingLicenceFileName || "Driving Licence"}
                    </div>

                    <div className="text-muted" style={{ fontSize: "12px" }}>
                      Uploaded Document
                    </div>
                  </div>
                </div>

                <img
                  src={viewIcon}
                  alt="View"
                  width={25}
                  style={{ cursor: "pointer" }}
                  onClick={() => handleEyeClick(formData.drivingLicenceFileUrl)}
                />
                {formData.drivingLicenceCanDelete && (
                  <img
                    src={deleteIcon}
                    alt="Delete"
                    width={25}
                    style={{ cursor: "pointer", marginLeft: "10px" }}
                    onClick={() =>
                      handleDeleteProfileDocument(
                        formData.drivingLicenceDocumentId,
                        "drivingLicenceFile",
                        "drivingLicenceFileUrl",
                        "drivingLicenceFileName",
                        "drivingLicenceDocumentId",
                      )
                    }
                  />
                )}
              </div>
            )}
          </div>
        </>
        {/* PASSPORT */}

        <>
          {/* Passport Number */}
          <div className="col-lg-3 col-md-4">
            <label className="form-label">Passport No</label>

            <input
              type="text"
              maxLength={8}
              placeholder="Enter Passport No"
              className={`form-control ${
                errors?.passportNo ? "is-invalid" : ""
              }`}
              name="passportNo"
              value={formData.passportNo || ""}
              onChange={(e) => {
                const value = e.target.value
                  .toUpperCase()
                  .replace(/[^A-Z0-9]/g, "");

                handleChange({
                  target: {
                    name: "passportNo",
                    value,
                  },
                });
              }}
              // disabled={hasPassport}
              disabled={formData.passportFromApi === true}
            />

            {errors?.passportNo && (
              <div className="invalid-feedback">{errors.passportNo}</div>
            )}
          </div>

          {/* Passport Upload */}
          <div className="col-lg-3 col-md-4">
            <label className="form-label">Passport Document</label>

            {!hasPassport ? (
              <div
                className="border rounded d-flex flex-column align-items-center justify-content-center upload-box"
                style={{
                  minHeight: "100px",
                  cursor: "pointer",
                }}
                onClick={() =>
                  document.getElementById("passportFileInput").click()
                }
              >
                <FontAwesomeIcon icon={faUpload} className="text-secondary" />

                <div
                  className="mt-2"
                  style={{
                    color: "#7b7b7b",
                    fontWeight: "500",
                  }}
                >
                  Click to upload
                </div>

                <div className="text-muted" style={{ fontSize: "12px" }}>
                  PDF, JPG or PNG (Max 2MB)
                </div>

                <input
                  id="passportFileInput"
                  type="file"
                  hidden
                  accept=".jpg,.jpeg,.png,.pdf"
                  onChange={(e) => {
                    const file = e.target.files[0];

                    if (!file) return;

                    const allowedTypes = [
                      "image/jpeg",
                      "image/jpg",
                      "image/png",
                      "application/pdf",
                    ];

                    if (!allowedTypes.includes(file.type)) {
                      toast.error(
                        "Only JPG, JPEG, PNG and PDF files are allowed",
                      );
                      e.target.value = "";
                      return;
                    }

                    if (file.size > 2 * 1024 * 1024) {
                      toast.error("File size should not exceed 2 MB");
                      e.target.value = "";
                      return;
                    }

                    handleProfileDocumentUpload(
                      e.target.files[0],
                      "PASSPORT",
                      "passportFile",
                      "passportFileUrl",
                      "passportFileName",
                      "passportDocumentId",
                    );
                  }}
                />
              </div>
            ) : (
              <div
                className="uploaded-file-box p-3 d-flex justify-content-between align-items-center"
                style={{
                  border: "2px solid #bfc8e2",
                  borderRadius: "8px",
                  background: "#f7f9fc",
                }}
              >
                <div className="d-flex align-items-center">
                  <img
                    src={greenCheck}
                    alt="check"
                    style={{
                      width: "22px",
                      height: "22px",
                      marginRight: "10px",
                    }}
                  />

                  <div>
                    <div
                      style={{
                        fontWeight: 600,
                        color: "#42579f",
                      }}
                    >
                      {formData.passportFileName || "Passport"}
                    </div>

                    <div className="text-muted" style={{ fontSize: "12px" }}>
                      Uploaded Document
                    </div>
                  </div>
                </div>

                <img
                  src={viewIcon}
                  alt="View"
                  style={{
                    width: "25px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleEyeClick(formData.passportFileUrl)}
                />
                {formData.passportCanDelete && (
                  <img
                    src={deleteIcon}
                    alt="Delete"
                    width={25}
                    style={{ cursor: "pointer", marginLeft: "10px" }}
                    onClick={() =>
                      handleDeleteProfileDocument(
                        formData.passportDocumentId,
                        "passportFile",
                        "passportFileUrl",
                        "passportFileName",
                        "passportDocumentId",
                      )
                    }
                  />
                )}
              </div>
            )}
          </div>
        </>
      </div>

      {/* Address For Correspondence */}
      <div className="px-4 pb-4 rounded row g-4 formfields bg-white border shadow-sm mb-5">
        {/* <p
                    className="tab_headers"
                    style={{ marginBottom: "0px", marginTop: "1rem" }}
                >
                    Address For Correspondence
                </p> */}
        <div className="section-header">
          <span className="section-header-title">
            Address For Correspondence
          </span>
        </div>

        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            Address Line 1 <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className={`form-control onboarding-input ${
              errors?.corrAddressLine1 ? "is-invalid" : ""
            }`}
            name="corrAddressLine1"
            value={formData.corrAddressLine1 || ""}
            onChange={handleAddressChange}
            placeholder="Enter Address Line 1"
          />
          {errors?.corrAddressLine1 && (
            <div className="invalid-feedback">{errors.corrAddressLine1}</div>
          )}
        </div>

        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            Address Line 2<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className={`form-control ${
              errors?.corrAddressLine2 ? "is-invalid" : ""
            }`}
            name="corrAddressLine2"
            value={formData.corrAddressLine2 || ""}
            onChange={handleAddressChange}
            placeholder="Enter Address Line 2"
          />
          {errors?.corrAddressLine2 && (
            <div className="invalid-feedback">{errors.corrAddressLine2}</div>
          )}
        </div>

        <div className="col-lg-3 col-md-6">
          <label className="form-label">Address Line 3</label>
          <input
            type="text"
            className={`form-control onboarding-input ${
              errors?.AddressLine3 ? "is-invalid" : ""
            }`}
            name="corrAddressLine3"
            value={formData.corrAddressLine3 || ""}
            onChange={handleAddressChange}
            placeholder="Enter Address Line 3"
          />
        </div>

        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            State <span className="text-danger">*</span>
          </label>

          <select
            className={`form-select ${errors?.corrState ? "is-invalid" : ""}`}
            value={formData.corrStateId}
            onChange={(e) => {
              const stateId = e.target.value;

              const state = states.find((item) => item.stateId === stateId);

              setFormData((prev) => ({
                ...prev,
                corrStateId: stateId,
                corrState: state?.stateName || "",
                corrDistrictId: "",
                corrDistrict: "",
                corrCityId: "",
                corrCity: "",
                corrPincode: "",
              }));
            }}
          >
            <option value="">Select State</option>

            {states.map((state) => (
              <option key={state.stateId} value={state.stateId}>
                {state.stateName}
              </option>
            ))}
          </select>
        </div>

        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            District <span className="text-danger">*</span>
          </label>

          <select
            className={`form-select ${errors?.corrDistrict ? "is-invalid" : ""}`}
            value={formData.corrDistrictId}
            onChange={(e) => {
              const districtId = e.target.value;

              const district = districts.find(
                (item) => item.districtId === districtId,
              );

              setFormData((prev) => ({
                ...prev,
                corrDistrictId: districtId,
                corrDistrict: district?.districtName || "",
                corrCityId: "",
                corrCity: "",
                corrPincode: "",
              }));
            }}
          >
            <option value="">Select District</option>

            {getDistrictsByState(formData.corrStateId).map((district) => (
              <option key={district.districtId} value={district.districtId}>
                {district.districtName}
              </option>
            ))}
          </select>
        </div>
        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            City <span className="text-danger">*</span>
          </label>

          <input
            type="text"
            className={`form-control ${errors?.corrCity ? "is-invalid" : ""}`}
            name="corrCity"
            value={formData.corrCity || ""}
            onChange={handleAddressChange}
            placeholder="Enter City"
          />

          {errors?.corrCity && (
            <div className="invalid-feedback">{errors.corrCity}</div>
          )}
        </div>

        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            Pincode <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className={`form-control ${
              errors?.corrPincode ? "is-invalid" : ""
            }`}
            name="corrPincode"
            value={formData.corrPincode || ""}
            onChange={handleAddressChange}
            placeholder="Enter Pincode"
            maxLength={6}
          />
          {errors?.corrPincode && (
            <div className="invalid-feedback">{errors.corrPincode}</div>
          )}
        </div>
      </div>

      {/* Permanent Address */}
      <div className="px-4 pb-4 rounded row g-4 formfields bg-white border shadow-sm mb-5">
        {/* <p
                    className="tab_headers"
                    style={{ marginBottom: "0px", marginTop: "1rem" }}
                >
                    Permanent Address
                </p> */}

        <div className="section-header">
          <span className="section-header-title">Permanent Address</span>
        </div>

        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            Address Line 1 <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className={`form-control onboarding-input ${
              errors?.permanentAddressLine1 ? "is-invalid" : ""
            }`}
            name="permanentAddressLine1"
            value={formData.permanentAddressLine1 || ""}
            onChange={handleAddressChange}
            placeholder="Enter Address Line 1"
          />
          {errors?.permanentAddressLine1 && (
            <div className="invalid-feedback">
              {errors.permanentAddressLine1}
            </div>
          )}
        </div>

        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            Address Line 2 <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className={`form-control ${
              errors?.permanentAddressLine2 ? "is-invalid" : ""
            }`}
            name="permanentAddressLine2"
            value={formData.permanentAddressLine2 || ""}
            onChange={handleAddressChange}
            placeholder="Enter Address Line 2"
          />
          {errors?.permanentAddressLine2 && (
            <div className="invalid-feedback">
              {errors.permanentAddressLine2}
            </div>
          )}
        </div>

        <div className="col-lg-3 col-md-6">
          <label className="form-label">Address Line 3</label>
          <input
            type="text"
            className={`form-control onboarding-input ${
              errors?.permanentAddressLine3 ? "is-invalid" : ""
            }`}
            name="permanentAddressLine3"
            value={formData.permanentAddressLine3 || ""}
            onChange={handleAddressChange}
            placeholder="Enter Address Line 3"
          />
        </div>
        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            State <span className="text-danger">*</span>
          </label>

          <select
            className={`form-select ${errors?.permState ? "is-invalid" : ""}`}
            value={formData.permStateId}
            onChange={(e) => {
              const stateId = e.target.value;

              const state = states.find((item) => item.stateId === stateId);

              setFormData((prev) => ({
                ...prev,
                permStateId: stateId,
                permState: state?.stateName || "",

                permDistrictId: "",
                permDistrict: "",

                permCity: "",

                permanentPincode: "",
              }));
            }}
          >
            <option value="">Select State</option>

            {states.map((state) => (
              <option key={state.stateId} value={state.stateId}>
                {state.stateName}
              </option>
            ))}
          </select>
          {errors?.permState && (
            <div className="invalid-feedback">{errors.permState}</div>
          )}
        </div>

        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            District <span className="text-danger">*</span>
          </label>

          <select
            className={`form-select ${errors?.permDistrict ? "is-invalid" : ""}`}
            value={formData.permDistrictId}
            onChange={(e) => {
              const districtId = e.target.value;

              const district = districts.find(
                (item) => item.districtId === districtId,
              );

              setFormData((prev) => ({
                ...prev,
                permDistrictId: districtId,
                permDistrict: district?.districtName || "",

                permCity: "",

                permanentPincode: "",
              }));
            }}
          >
            <option value="">Select District</option>

            {getDistrictsByState(formData.permStateId).map((district) => (
              <option key={district.districtId} value={district.districtId}>
                {district.districtName}
              </option>
            ))}
          </select>
          {errors?.permDistrict && (
            <div className="invalid-feedback">{errors.permDistrict}</div>
          )}
        </div>
        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            City <span className="text-danger">*</span>
          </label>

          <input
            type="text"
            className={`form-control ${errors?.permCity ? "is-invalid" : ""}`}
            name="permCity"
            value={formData.permCity || ""}
            onChange={handleAddressChange}
            placeholder="Enter City"
          />

          {errors?.permCity && (
            <div className="invalid-feedback">{errors.permCity}</div>
          )}
        </div>

        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            Pincode <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className={`form-control ${
              errors?.permanentPincode ? "is-invalid" : ""
            }`}
            name="permanentPincode"
            value={formData.permanentPincode || ""}
            onChange={handleAddressChange}
            placeholder="Enter Pincode"
            maxLength={6}
          />
          {errors?.permanentPincode && (
            <div className="invalid-feedback">{errors.permanentPincode}</div>
          )}
        </div>
        <div className="col-lg-3 col-md-6">
          <label className="form-label">
            Upload Address Proof (Permanent/Correspondence)
            {/* <span className="text-danger">*</span> */}
          </label>

          {!(formData.addressProofFile || formData.addressProofFileUrl) ? (
            <div
              className="border rounded d-flex flex-column align-items-center justify-content-center upload-box"
              style={{
                minHeight: "100px",
                cursor: "pointer",
              }}
              onClick={() =>
                document.getElementById("addressProofFileInput").click()
              }
            >
              <FontAwesomeIcon icon={faUpload} className="text-secondary" />

              <div
                className="mt-2"
                style={{
                  color: "#7b7b7b",
                  fontWeight: "500",
                }}
              >
                Click to upload
              </div>

              <div className="text-muted" style={{ fontSize: "12px" }}>
                PDF, JPG or PNG (Max 2MB)
              </div>

              <input
                id="addressProofFileInput"
                type="file"
                accept=".jpg,.jpeg,.png,.pdf"
                style={{ display: "none" }}
                onChange={async (e) => {
                  const file = e.target.files[0];

                  if (!file) return;

                  const allowedTypes = [
                    "image/jpeg",
                    "image/jpg",
                    "image/png",
                    "application/pdf",
                  ];

                  if (!allowedTypes.includes(file.type)) {
                    toast.error(
                      "Only JPG, JPEG, PNG and PDF files are allowed",
                    );
                    e.target.value = "";
                    return;
                  }

                  if (file.size > 2 * 1024 * 1024) {
                    toast.error("File size should not exceed 2 MB");
                    e.target.value = "";
                    return;
                  }

                  setFormData({
                    ...formData,
                    addressProofFile: file,
                  });

                  setErrors((prev) => {
                    const updated = { ...prev };
                    delete updated.addressProofFile;
                    return updated;
                  });

                  await handleAddressProofUpload(file);
                }}
              />
            </div>
          ) : (
            <div
              className="uploaded-file-box p-3 d-flex justify-content-between align-items-center"
              style={{
                border: "2px solid #bfc8e2",
                borderRadius: "8px",
                background: "#f7f9fc",
              }}
            >
              <div className="d-flex align-items-center">
                <img
                  src={greenCheck}
                  alt="check"
                  style={{
                    width: "22px",
                    height: "22px",
                    marginRight: "10px",
                  }}
                />

                <div>
                  <div
                    style={{
                      fontWeight: 600,
                      color: "#42579f",
                    }}
                  >
                    {formData.addressProofFile?.name ||
                      formData.addressProofFileUrl?.split("/").pop()}
                  </div>

                  <div className="text-muted" style={{ fontSize: "12px" }}>
                    {formData.addressProofFile
                      ? `${(formData.addressProofFile.size / 1024).toFixed(
                          1,
                        )} KB`
                      : "Uploaded Document"}
                  </div>
                </div>
              </div>

              <div className="d-flex gap-2">
                <img
                  src={viewIcon}
                  alt="View"
                  style={{
                    width: "25px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    if (formData.addressProofFile) {
                      window.open(
                        URL.createObjectURL(formData.addressProofFile),
                        "_blank",
                      );
                    } else if (formData.addressProofFileUrl) {
                      handleEyeClick(formData.addressProofFileUrl);
                    }
                  }}
                />

                <img
                  src={deleteIcon}
                  alt="Delete"
                  width={20}
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    handleDeleteProfileDocument(
                      formData.addressProofDocumentId,
                      "addressProofFile",
                      "addressProofFileUrl",
                      "addressProofFileName",
                      "addressProofDocumentId",
                    )
                  }
                />
              </div>
            </div>
          )}

          {/* {errors?.addressProofFile && (
            <small className="text-danger d-block mt-1">
              {errors.addressProofFile}
            </small>
          )} */}
        </div>
      </div>
    </>
  );
};

export default Details;
